import { ActionTypes } from 'constants/AdminConstants';
import Dispatcher from '../dispatcher/Dispatcher';
export function setClientKey(key, value) {
    var action = {
        type: ActionTypes.SET_CLIENT_KEY,
        key: key,
        value: value
    };
    Dispatcher.dispatch(action);
}
export var removeClientKey = function (key) {
    var action = {
        type: ActionTypes.DELETE_CLIENT_KEY,
        key: key
    };
    Dispatcher.dispatch(action);
};
export default {
    setClientKey: setClientKey,
    removeClientKey: removeClientKey
};
